import React, { useEffect, useContext, useState, useCallback } from 'react';
import ComposeEmailView from '../view/ComposeEmailView';
import cloneDeep from 'lodash/cloneDeep';
import { Context } from './EmailDialogEngine';
import sortInfoNames from '../../utils/sortInfoNames';
import useTranslations from '../../hooks/useTranslations';

const ComposeEmailEngine = ({
  data,
  to = [],
  readOnlyEmailsList: roel,
  usersCount4FilterQuery,
  aggregateEmailsDisplay,
  sharedUsers = [],
  formId4RequestingInfo,
  submissionId
}) => {
  const { dispatch } = useContext(Context);
  const [toggleCcSharedUsers, setToggleCcSharedUsers] = useState(false);
  const [readOnlyEmailsList, setReadOnlyEmailsList] = useState(roel); // to be able to override the given readOnlyEmailsList prop if needed
  const t = useTranslations();

  useEffect(() => {
    if (to.length) {
      // if we received emails list (list of ids or query) we can't allow the user
      // to edit the list of emails becuase we can't add the user input
      // to the API and support the received emails list (list of ids or query).
      setReadOnlyEmailsList(true);

      if (Array.isArray(to)) {
        // we got an array
        let emails = [];
        if (aggregateEmailsDisplay && to.length > 1) {
          emails = [to[0].email, `and ${to.length - 1} more`];
        } else {
          emails = to.map(addressNode => addressNode.email);
        }
        setTimeout(() => {
          // wrapped in setTimeout to avoid race conditions with parent cmp
          dispatch({ type: 'update', payload: { emails } });
        }, 1);
      } else {
        // we got a query
        const displayText =
          usersCount4FilterQuery > 0
            ? t('email_dialog.matching_filters', {
                count: usersCount4FilterQuery
              })
            : t('email_dialog.matching_filters.noCount');

        setTimeout(() => {
          // wrapped in setTimeout to avoid race conditions with parent cmp
          dispatch({
            type: 'update',
            payload: {
              emails: [displayText]
            }
          });
        }, 1);
      }
    }
  }, []); // TODO: make sure this works (can be set only for the first time)

  const onCcSharedUsersToggeled = useCallback(
    event => {
      const checked = event.target.checked;
      const sharedUsersEmails = sharedUsers.map(one => one.info.email);
      setToggleCcSharedUsers(checked);

      // TODO: can add here trim to strings
      let newCcArray = [];
      if (checked) {
        const ccSet = new Set([...data.cc, ...sharedUsersEmails]);
        newCcArray = [...ccSet];
      } else {
        newCcArray = data.cc.filter(email => sharedUsersEmails.includes(email));
      }
      dispatch({ type: 'update', payload: { cc: newCcArray } });
    },
    [setToggleCcSharedUsers, sharedUsers]
  );

  let recipientOptions = [];

  if (to && to.length) {
    recipientOptions.push(cloneDeep(to[0]));
  }

  if (sharedUsers) {
    recipientOptions = recipientOptions.concat(...sharedUsers);
  }

  recipientOptions.sort(sortInfoNames);

  const viewProps = {
    emails: data.emails,
    cc: data.cc,
    subject: data.subject,
    body: data.body,
    readOnlyEmailsList,
    sharedUsers,
    defaultRecipient: to[0],
    toUserIds: data.toUserIds,
    recipientOptions,
    formId4RequestingInfo,
    submissionId,
    toggleCcSharedUsers,
    onCcSharedUsersToggeled
  };

  return <ComposeEmailView {...viewProps} />;
};

export default ComposeEmailEngine;
